import { Injectable, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService, UsedSgkz011aService } from 'cbc-shared-lib';

import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd005aService,
  Sgkd005aRequest,
  Sgkd005aRequestAceptInfo,
  Sgkd005aRequestPayInfo,
  Sgkd005aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd002dSgkd005aService {

  private _rsesult$ = new Subject<Sgkd005aResponse>();

  constructor(
    private sgkd005aService: Sgkd005aService,
    private apiCommonService: ApiCommonService,
    private usedSgkz011aService: UsedSgkz011aService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKD005A_支払方法変更_受付登録API呼び出し
   * ＣＶＳ払込票／請求書払い／特定払込票
   *
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param aceptNo 受付番号
   * @param payMethodDiv 支払方法コード
   * @memberof UsedSgkd002dSgkd005aService
   */
  addCsvInfo(recptFixNo: string, date: string, aceptNo: string,
    payMethodDiv: string): Observable<Sgkd005aResponse> {
    return this.addPayInfo(recptFixNo, aceptNo,
      {
        // 支払方法コード
        payMthdiv: payMethodDiv,
        // 申込日付
        srnDate: date,
        kohuri: {},
        yuchofrikae: {},
        crd: {},
        smssettlement:{}
      });
  }

  /**
   * SGKD005A_支払方法変更マスタ反映_おしらせ通知API呼び出し
   * 口座振替
   *
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param aceptNo 受付番号
   * @param kozaForm 口座振替フォーム
   * @memberof UsedSgkd002dSgkd005aService
   */
  addKouzaInfo(recptFixNo: string, date: string, aceptNo: string,
    kozaForm: UntypedFormGroup): Observable<Sgkd005aResponse> {
    return this.addPayInfo(recptFixNo, aceptNo,
      {
        // 支払方法コード
        payMthdiv: SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA,
        // 申込日付
        srnDate: date,
        // 口座振替
        kohuri: {
          // 口座名義（漢字）
          kohuriActknj: kozaForm.get('kohuriActknj').value,
          // 口座名義（カナ）
          kouzaMeigiKana: kozaForm.get('meigiKana').value,
          // 外部金融機関コード
          extBankfcCode: kozaForm.get('extBankfcCode').value,
          // 外部支店コード
          extBranchCode: kozaForm.get('extBranchCode').value,
          // 預金種別コード
          dptClsfy: kozaForm.get('dptClsfy').value,
          // 口座番号
          kouzaNo: kozaForm.get('kouzaNo').value,
          // 受取方法区分コード
          recivWaydiv: kozaForm.get('recivWayDivcd').value,
          // 口振翌月請求区分コード
          kohuriNmcdiv: SgKdConstants.CODE.KOHURI_NMCDIV.TOUGETSU,
        },
        yuchofrikae: {},
        crd: {},
        smssettlement:{}
      });
  }

  /**
   * SGKD005A_支払方法変更マスタ反映_おしらせ通知API呼び出し
   * クレジット
   *
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param aceptNo 受付番号
   * @param creditForm クレジットフォーム
   * @memberof UsedSgkd002dSgkd005aService
   */
  addCreditInfo(recptFixNo: string, date: string, aceptNo: string,
    creditForm: UntypedFormGroup): Observable<Sgkd005aResponse> {
    return this.addPayInfo(recptFixNo, aceptNo,
      {
        // 支払方法コード
        payMthdiv: SgKdConstants.CODE.PAYMETHOD.USER_CODE.CRD,
        // 申込日付
        srnDate: date,
        kohuri: {},
        yuchofrikae: {},
        // クレジット
        crd: {
          /** クレ企業コード */
          crdcoCode: creditForm.get('crdcomCoCode').value,
          /** 収納代行連携キー */
          crdLinkKey: creditForm.get('crdLinkKey').value,
          /** クレお客さまカナ氏名 */
          crdVisitKana: creditForm.get('cardMeigiKana').value
        },
        smssettlement:{}
      });
  }

  /**
   * SGKD005A_支払方法変更マスタ反映_おしらせ通知API呼び出し
   * ＳＭＳ決済
   *
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param aceptNo 受付番号
   * @param smsForm ＳＭＳ決済フォーム
   * @memberof UsedSgkd002dSgkd005aService
   */
  addSmsInfo(recptFixNo: string, date: string, aceptNo: string,
    smsForm: UntypedFormGroup): Observable<Sgkd005aResponse> {
    return this.addPayInfo(recptFixNo, aceptNo,
      {
        // 支払方法コード
        payMthdiv: SgKdConstants.CODE.PAYMETHOD.USER_CODE.SMS,
        // 申込日付
        srnDate: date,
        kohuri: {},
        yuchofrikae: {},
        crd: {},
        // ＳＭＳ決済
        smssettlement: {
          /** 携帯電話番号 */
          cellphonenumber: smsForm.get('cellphonenumber').value
        }
      });
  }

  /**
   * SGKD005A_支払方法変更マスタ反映_おしらせ通知API呼び出し
   *
   * @param recptFixNo 請求お客さま番号
   * @param aceptNo 受付番号
   * @param payInfo 支払情報
   * @memberof UsedSgkd002dSgkd005aService
   */
  private addPayInfo(recptFixNo: string, aceptNo: string, payInfo: Sgkd005aRequestPayInfo): Observable<Sgkd005aResponse> {
    // リクエスト生成
    let request: Sgkd005aRequest = {
      requestDto: {
        // 受付情報
        aceptInfo: this.createAceptInfo(recptFixNo, aceptNo),
        // 支払情報
        payMethodInfo: payInfo
      }
    }

    // リクエスト情報生成
    let req = this.apiCommonService.setRequestCommon(request);

    // 二重登録ユニークキー生成
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyymmdd = `${now.getFullYear()}${mm}${dd}`;
    const hh = String(now.getHours()).padStart(2, "0");
    const mi = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");
    const ms = String(now.getMilliseconds()).padStart(3, "0");
    const timeWithMs = `${hh}${mi}${ss}${ms}`;
    // 業務リクエストID・機能連携IDに設定
    req.requestCommon.businessReqId = yyyymmdd;
    req.requestCommon.funcLinkId = timeWithMs;
    console.log("UsedSgkd002dSgkd005aService req", req);

    return this.sgkd005aService.doSGKD005APost(req, 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD005A');
          return throwError(err.message);
        }
      )
    );
  }

  /**
   * 受付情報の生成
   * @param recptFixNo 請求お客さま番号
   * @returns 受付情報
   * @memberof UsedSgkd002dSgkd005aService
   */
  private createAceptInfo(recptFixNo: string, aceptNo: string): Sgkd005aRequestAceptInfo {
    // 組織情報取得
    let sosikiId = SgKdConstants.STR.EMPTY;
    this.usedSgkz011aService.userOrganizationInfo.subscribe(info => {
      sosikiId = info.sosikiId;
    });
    console.log("createAceptInfo sosikiId", sosikiId);

    return {
      // 請求お客さま番号
      recptFixNo: recptFixNo,
      // 受付番号
      aceptNo: aceptNo,
      // 受付担当組織番号
      aceptSosikiCode: sosikiId,
      // 申込方法
      srnMethod: SgKdConstants.CODE.PAY_METHOD_REG_MTD_DIV.USER_CODE.ONLINE
    }
  }

}
